import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { connect } from 'react-redux';
import Loader from "../loader";
import Table, { TableProps } from "antd/lib/table";
import { Select } from 'antd';
import '../../assets/css/style.css'
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import Layout from '../Layout';
import '../../../src/custom.css'
import axios from "axios"
import updateIcon from "../../assets/images/updateIcon.svg"
import { Modal } from 'antd';
import { Tooltip } from 'antd';
import { fetchAllQrCodesData, fetchSiteDetails, fetchCompanyDetails, fetchSitesWithParentCompany, updateInstLocation, fetchLocationProducts } from '../../Redux/Api/fetch.api';
import { getQrCodeData, updateQRCodeData } from '../../Redux/Actions/QR';
import { setLocationType, updateInstLocationData } from '../../Redux/Actions/LocationActions';
import { useTranslation } from "react-i18next";
import * as url from "../../api/uri_helper"
import { SetCompanyDetails } from "../../Redux/Actions/CompanyActions";

const TOAST_LIMIT = 1;
const LocationUpdate = () => {
    const { t } = useTranslation("dashboard");
    const { toasts } = useToasterStore();
    useEffect(() => {
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
    }, [toasts]);
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: 50,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['50', '100']
        }
    });
    const [selectedLocationIds, setSelectedLocationIds] = useState({});
    // const [options, setOptions] = useState({ pagination: { current: 1 }, pageSize: pageSize });
    const [pageSize, setPageSize] = useState(50);
    const [loading, setLoading] = useState(false);
    const [locname, setLocname] = useState([{}]);
    const [table, setTable] = useState([]);
    const [total, setTotal] = useState()
    const [currentLocationId, setCurrentLocationId] = useState()
    const [qRcode, setQRCode] = useState("");
    const [updatedLocationId, setUpdatedLocationId] = useState()
    const [currentCompanyId, setCurrentCompanyId] = useState()
    const [bulkLocationId, setBulkLocationId] = useState()
    const [disabledUpdate, setDisabledUpdate] = useState(true)
    const [qrCodeId, setQrCodeId] = useState([{}]);
    const [qRcodeError, setQRCodeError] = useState(false);
    const [count, setCount] = useState(0);
    const [pageData, setPageData] = useState({});
    const [copyModal, setCopyModal] = useState(false);
    const [checkedListOfIds, setCheckedListOfIds] = useState([]);
    const [companyData, setCompanyData] = useState([]);
    const [getRadioButton, setGetRadioButton] = useState({ show: "show", selected: "show", });
    const [searchOptions, setSearchOptions] = useState({
        pagination: { current: 1 }, pageSize: pageSize
    })
    const dispatch = useDispatch();
    const [siteData, setSiteData] = useState([]);
    const allLocationTypes = useSelector((state) => state.allLocationType.location)
    const [filteredSiteOptions, setFilteredSiteOptions] = useState([]);


    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        getAllQRCodes(options, true);
        //  getProducts();
        getAllCompanies();
        getAllSites();
    }, [])

    const handleChange = (pagination) => {
        setOptions(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current: pagination.current,
                pageSize: pagination.pageSize,
            }
        }));

        getAllQRCodes({
            pagination: {
                current: pagination.current,
                pageSize: pagination.pageSize
            }
        });
    };

    const getAllSites = () => {

        setLoading(true)
        fetchSitesWithParentCompany()
            //fetchSiteDetails()
            .then(response => {

                if (response.data.success) {
                    setSiteData(response.data.data)
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const handleInputForSiteDropdown = (input) => {

        const filtered = siteData && siteData.filter(item => {
            const fullName = item.siteName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredSiteOptions(filtered);
    };

    const handleCheck = (qRcodeId) => {

        var updatedList = [...checkedListOfIds];
        if (event.target.checked) {
            updatedList = [...checkedListOfIds, qRcodeId];
        } else {
            updatedList.splice(checkedListOfIds.indexOf(qRcodeId), 1);
        }
        setCheckedListOfIds([...updatedList]);

    };

    const radioButtonValueChange = (e) => {
        if (e.target.value === "show") {
            setGetRadioButton({
                show: "show",
                selected: e.target.value,
            });
        } else {
            setGetRadioButton({
                show: "hide",
                selected: e.target.value,
            });
        }
    };

    const getProducts = () => {
        setLoading(true)
        fetchLocationProducts()
            .then(response => {
                dispatch(setLocationType(response.data));
                setLocname(response.data.data.name)

            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getAllCompanies = () => {
        setLoading(true)
        fetchCompanyDetails()
            .then(response => {
                dispatch(SetCompanyDetails(response.data));
                setCompanyData(response.data.data);
            })
            .catch((err) => {
                console.log("Err: ", err);
            })

    }



    const uncheckcheckbox = () => {
        var items = document.getElementsByName('checkname');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
    }

    const handleBulkLocationUpdate = async () => {

        setLoading(true)
        if (checkedListOfIds.length >= 1) {
            const data = [];
            checkedListOfIds.map(x => data.push({
                QRcodeId: x,
                LocationId: bulkLocationId
            }))
            const response = await axios.put(url.UPDATE_INSTLOCATION,
                {
                    "InstLocationQrs": data
                }).then(response => {

                    dispatch(updateInstLocationData(response.data))
                    setBulkLocationId();
                    if (!response.data.success) // False 
                    {

                        toast.error(response.data.message, {
                            className: "toastSuccess",
                        });
                    }
                    else {
                        toast.success(response.data.message, {
                            className: "toastSuccess",
                        })
                    }
                    setLoading(false)
                })
            getAllQRCodes(options, false)
            setCheckedListOfIds('')
            uncheckcheckbox();
            setDisabledUpdate(true)
        }
    };

    const getFullInstalDate = (date) => {
        // setLoading(true)
        if (date) {
            const dateAndTime = date.split('T');
            const time = dateAndTime[1].split(':')
            const newtime = time[0] + ' : ' + time[1]
            const times = time[0] > 12 ? time[0] % 12 : time[0]
            const newtime1 = times + ' : ' + time[1]
            if (time[0] && time[0] >= 12) {
                return dateAndTime[0].split('-').reverse().join('-') + ',' + newtime1 + " PM ";
            }
            else {
                return dateAndTime[0].split('-').reverse().join('-') + ',' + newtime + " AM ";
            }
        }
    };

    const handleSingleLocationUpdate = async (qRcodeId, currentLocationId) => {
        setLoading(true)
        if (currentLocationId) {
            const response = await axios.put(url.UPDATE_INSTLOCATION, {
                "InstLocationQrs": [{
                    "QRcodeId": qRcodeId,
                    "LocationId": currentLocationId
                }]
            }).then(response => {

                dispatch(updateInstLocationData(response.data.data))
                if (!response.data.success) // False 
                {
                    toast.error(response.data.message, {
                        className: "toastSuccess",
                    });

                }
                else {
                    toast.success(response.data.message, {
                        className: "toastSuccess",
                    });
                }
                setLoading(false)
            })
            getAllQRCodes(options, false)
        }

    };



    const getAllQRCodes = (options, isReset = false) => {

        if (options && options.pagination == undefined) {
            options.pagination = pageData.pagination;
            options.pageSize = pageData.pageSize;
        }
        fetchAllQrCodesData(isReset ? 0 : (qRcode > 0 ? qRcode : 0))
            .then(response => {

                setTable(response.data.data)
                setQrCodeId(response.data.data.qRcodeId)
                setTotal(response.data.count)
                setOptions({
                    ...options,
                    pagination: {
                        pageSize: options.pagination.pageSize,
                        current: options.pagination.current,
                        total: response.data.count,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }
    const { Option } = Select;
    const columns = [

        ...(getRadioButton.selected === "hide" ?
            [
                {
                    title: " ",
                    dataIndex: "qRcodeId",
                    hidden: false,
                    render: (qRcodeId) => (<div className="checkgroup">
                        {
                            <input type="checkbox" className="btn-checkbox" name="checkname"

                                onChange={() => { handleCheck(qRcodeId) }}
                                key={qRcodeId}
                            ></input>
                        }
                    </div>)
                },
            ] : []
        ),
        {
            title: t("QRCodesTitle"),
            dataIndex: "qRcodeId",
            className: "update_qrcode"
        },

        {
            title: t("ProductName"),
            className: "update_qrcode",
            dataIndex: "product_Name",
            render: (product_Name) => <Tooltip placement='topLeft' className="media-tooltip prdouct-name" title={product_Name}>{product_Name ? product_Name : "- NA -"}</Tooltip>,
        },

        {
            title: t("InstDate"),
            className: "update_qrcode",
            dataIndex: "installation_Date",
            //key: 'installation_Date',

            render: ((date) => getFullInstalDate(date))

        },

        {
            title: t("ManDate"),
            className: "update_qrcode",
            dataIndex: "manufacturing_Date",
            //key: 'installation_Date',

            render: ((date) => getFullInstalDate(date))

        },
        ...(getRadioButton.selected === "hide" ?
            [
                {
                    title: t("Site"),
                    className: "update_qrcode",
                    dataIndex: "",
                    render: (text, record, index) => (
                        <>
                            {record.locationName}
                        </>
                    )

                },
            ] : []
        ),

        ...(getRadioButton.selected === "hide" ?
            [
                {
                    title: t("Company"),
                    className: "update_qrcode",
                    dataIndex: "",
                    render: (text, record, index) => (
                        <>
                            {record.companyName}
                        </>
                    )

                },
            ] : []
        ),

        ...(getRadioButton.selected === "show" ?
            [
                {
                    title: t("Site"),
                    key: 'i',
                    hidden: true,
                    render: (record, row, i) => (

                        <div className='d-flex qrTable--select qr-img-select mapping wkmapping' >
                            <Select class="form-select mb-0 flex-grow-1 filter-select " aria-label=".form-select-lg example"
                                showSearch
                                style={{ width: 250 }}
                                placeholder={t("UpdateSitePlaceholder")}
                                id={i + 1}
                                key={row.qRcodeId}
                                defaultValue={selectedLocationIds[record.qRcodeId] || record.locationId}
                                onChange={(value) => {
                                    setSelectedLocationIds(prev => ({
                                        ...prev,
                                        [record.qRcodeId]: value
                                    }));
                                }}
                                // defaultValue={record.locationId}
                                // onChange={(e) => setCurrentLocationId(e)}
                                onSearch={(value) => {
                                    handleInputForSiteDropdown(value)
                                }}
                                filterOption={false}

                            >
                                {/*  <Option key={0} value={record.locationId}>{} </Option>*/}
                                {filteredSiteOptions.length > 0 ?
                                    filteredSiteOptions && filteredSiteOptions.map(item =>
                                        <Option key={item.siteId} value={item.siteId}>
                                            {`${item.siteName} - ${item.parentCompanyName}`}
                                        </Option>
                                    )
                                    :
                                    siteData && siteData.map(item =>
                                        <Option key={item.siteId} value={item.siteId}>
                                            {`${item.siteName} - ${item.parentCompanyName}`}
                                        </Option>
                                    )
                                }

                            </Select>
                        </div>

                    )

                }
            ] : []
        ),

        ...(getRadioButton.selected === "show" ?
            [
                {
                    title: t("Company"),
                    className: "update_qrcode",
                    dataIndex: "",
                    render: (text, record, index) => (
                        <>
                            {record.companyName}
                        </>
                    )

                },
            ] : []
        ),




        ...(getRadioButton.selected === "show" ?
            [
                {
                    title: t("UpdateTitle"),
                    key: 'index',
                    hidden: true,
                    //  className: "update_mapping",
                    render: (text, record, index) => (<>

                        <button className="assign-btn btn " id={index + 1}>
                            <img src={updateIcon}
                                onClick={() => {
                                    const selectedValue = selectedLocationIds[record.qRcodeId] || record.locationId;

                                    if (selectedValue !== record.locationId) {
                                        handleUpdate(record.qRcodeId, selectedValue);
                                    } else {
                                        console.log("No changes to update.");

                                    }
                                }}
                            ></img>
                        </button>
                    </>)
                }
            ] : []
        )
    ]

    const { confirm } = Modal;
    const handleUpdate = (qRcodeId, currentLocationId) => {

        confirm({
            title: t("ConfirmUpdateSite"),
            okText: t("Yes"),
            okType: 'danger',
            cancelText: t("No"),
            onOk() {
                handleSingleLocationUpdate(qRcodeId, currentLocationId)
            },
            onCancel() {
            },
        });
    }

    const handleResetButton = async () => {
        setQRCodeError("")
        setQRCode("")
        getAllQRCodes(options, true)

    }

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            getAllQRCodes(options, false)
        }
    }

    return (
        <Layout title={t("LocationUpdate")}>
            <Toaster />
            <>
                <div className="row m-0">
                    <div class="col-md-12 d-flex pt-3 pb-0 align-items-center flex-wrap gap-3">
                        <div className="">
                            {" "}
                            <input
                                type="radio"
                                value="show"
                                name="content"
                                id="show"
                                className="mr-2"
                                onClick={radioButtonValueChange}
                                checked={getRadioButton.selected === "show"}
                            />
                            <label className="m-0" for="show">{t("SingleSiteUpdate")}</label>
                        </div>
                        <div className="">
                            {" "}
                            <input
                                className="mr-2"
                                type="radio"
                                value="hide"
                                name="content"
                                id="hide"
                                onClick={radioButtonValueChange}
                                checked={getRadioButton.selected === "hide"}
                            />
                            <label className="m-0" for="show">{t("BulkSiteUpdate")}</label>{" "}
                        </div>
                    </div>
                    <div class="col-md-6 d-flex pt-3 pb-3 align-items-center flex-wrap gap-3">


                        <div className="w-100 d-flex gap-3 filter-box1 flex-wrap">
                            <span className="">{t("SearchByQR")}</span>
                            <div className="d-flex flex-column gap-2 width-box position-relative">
                                <input type="text" className='form-control searchQR w-100 m-0' value={qRcode} placeholder={t("EnterQR")}
                                    // onKeyPress={(e) => {
                                    //     if (new RegExp(/^[0-9\b]+$/).test(e.key)) {
                                    //     } else e.preventDefault();
                                    // }}
                                    inputMode="numeric"

                                    onKeyDown={(e) => handleKeyPress(e)}
                                    onChange={(e) => {
                                        // const val = e.target.value.trim();
                                        const onlyDigits = e.target.value.replace(/\D/g, "");
                                        setQRCode(onlyDigits);
                                        setCount(onlyDigits.length);

                                        if (onlyDigits === "") {
                                            setQRCodeError("");
                                            getAllQRCodes(options, true);
                                        } else if (onlyDigits.startsWith("0")) {
                                            setQRCodeError(t("EnterValidQR"))
                                        } else {
                                            setQRCodeError("");
                                        }
                                    }}
                                >
                                </input>
                                {qRcodeError != "" ?
                                    <small className='text-danger d-block qRcodeError top-100' >{qRcodeError}</small> : ""
                                }
                            </div>
                            <button className="searchButton"
                                onClick={() => {
                                    if (qRcode.trim() === "") { setQRCodeError(t("PleaseEnterQRCode")) }
                                    else if (count < 2 && qRcode != "") { setQRCodeError(t("EnterValidQRCodeError")) }
                                    else { setQRCodeError("") }
                                    if (count > 2) {
                                        getAllQRCodes(options, false)
                                    }
                                }}
                            // disabled={!qRcode}


                            >{t("Search")}</button>
                            {qRcode == "" ? "" : <button className='searchButton'
                                onClick={() =>
                                    handleResetButton()}
                            >{t("Reset")}</button>}

                        </div>
                    </div>



                    {getRadioButton.show == "hide" ? (
                        <div className="col-md-6 d-flex pt-3 pb-3 align-items-center flex-wrap gap-2 justify-content-end update_location" >
                            <span className="location-span">{t("UpdateSiteLabel")}</span>
                            <Select class="form-select mb-0 flex-grow-1 filter-select " aria-label=".form-select-lg example"
                                showSearch
                                style={{ width: 250 }}
                                placeholder={t("UpdateSitePlaceholder")}
                                value={bulkLocationId}
                                onSearch={(value) => {
                                    handleInputForSiteDropdown(value)
                                }}
                                filterOption={false}

                                onChange={(e) => {

                                    setBulkLocationId(e)
                                }}
                            >
                                {filteredSiteOptions.length > 0 ?
                                    filteredSiteOptions && filteredSiteOptions.map(item =>
                                        <Option key={item.siteId} value={item.siteId}>
                                            {`${item.siteName} - ${item.parentCompanyName}`}
                                        </Option>
                                    )
                                    :
                                    siteData && siteData.map(item =>
                                        <Option key={item.siteId} value={item.siteId}>
                                            {`${item.siteName} - ${item.parentCompanyName}`}
                                        </Option>
                                    )
                                }

                            </Select>

                            {
                                getRadioButton.show == "hide" ?
                                    checkedListOfIds.length >= 1 && bulkLocationId ?
                                        <button className="btn btn-primary location-btn" onClick={() => handleBulkLocationUpdate()}>{t("BulkSiteUpdate")}</button> :
                                        <button className="btn btn-primary location-btn" disabled onClick={() => handleBulkLocationUpdate()}>{t("BulkSiteUpdate")}</button>

                                    : ""
                            }
                        </div>
                    ) : ""}



                </div>


                {
                    getRadioButton.show == "show" ?

                        <div className="Viewer-table position-relative mb-4 pagination-sticky">
                            {loading ? <Loader /> : ''}
                            <Table
                                className='table-responsive antd--detail-table Viewer-table'
                                columns={columns}
                                dataSource={table}
                                pagination={
                                    total > 50 ? options.pagination : false
                                }
                                // pagination={options.pagination.total > 10 ? options.pagination : false}
                                onChange={handleChange}
                            // paginationTotalRows={total}
                            />
                        </div> :
                        <div className="Viewer-table position-relative mb-4 pagination-sticky update_loc">
                            {loading ? <Loader /> : ''}
                            <Table
                                className='table-responsive antd--detail-table Viewer-table'
                                columns={columns}
                                dataSource={table}
                                pagination={
                                    total > 50 ? options.pagination : false
                                }
                                // pagination={options.pagination.total > 10 ? options.pagination : false}
                                onChange={handleChange}
                            // paginationTotalRows={total}
                            />
                        </div>}


            </>
        </Layout>

    )

}

export default connect()(LocationUpdate);
